
import { LoadingButton } from '@mui/lab'
import { Box, Button, IconButton, SxProps, Tooltip, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
  BaseMenu,
  BreadCrumb,
  CustomTable,
  SnackSimple,
} from '../../../../components'
import { DinamicForm } from '../../../../components/dinamicForm'
import { ModelDownloadButtons } from '../../../../components/donwloadFiles/model'
import { FiltersDrawer } from '../../../../components/filtersDrawer'
import BaseModal from '../../../../components/modal/baseModal'
import SimpleModal from '../../../../components/modal/simpleModal'
import { useDownload } from '../../../../hooks/download/useDownload'
import { useContextState } from '../../../../hooks/theme'
import { useTimeOut } from '../../../../hooks/timeOut'
import { actionPlanFetch, userScheduleServiceFetch } from '../../../../utils/constants/callService'
import { Types } from '../../../../utils/enums'
import { icons } from '../../../../utils/icons'
import { handleAllErrors } from '../../../../utils/methods/handleErrors'
import {
  returnQuery,
  returnQueryWithPagination,
} from '../../../../utils/methods/returnQuery'
import { Item, ObjectGeneric, onChange } from '../../../../utils/types/generals'
import { isEmailSeparateToCome } from '../../../../utils/validate/validate'
import { formatGenerateReportResponse } from '../../../calendar/pages/detail/methods/formatResponse'
import { resendReportTypes } from '../../../calendar/pages/main/constants/typeResendReport'
import { useUserScheduleContext } from '../../context'
import { DetailModal } from './components/detailModal'
import { formOrder } from './constants/filters'
import { resendReportForm, resendReportFormEmails } from './constants/general'
import { useTable } from './hooks/table'
import { useStyles } from './styles'
import { OptionMenu, SubmitResend } from './types'
import { FrequencyEnumTable, ScheduleEnumType } from '../../../calendar/pages/form/components/steps/configCalendar/enums'
import { TypeDeleteSchedule } from '../../../calendar/pages/main/enums/enums'

const UserScheduled = () => {
  const { executeFunction } = useTimeOut()
  const navigate = useNavigate()
  const styles = useStyles()
  const { t } = useTranslation()
  const { colors } = useContextState()
  const { userFilterData, input, userSchedule, disabledInputs } = useUserScheduleContext()
  const {
    row,
    setRow,
    isLoading,
    endpointDetail,
    getUserSchedule,
  } = userFilterData

  const [disabledModal, setDisabledModal] = useState({
    resendButton: true,
    resendButtonLoading: false,
  })
  const [resendReport, setResendReport] = useState<{
    title: string
    open: boolean
    close: () => void,
    send: (data: { data: ObjectGeneric }) => void,
    values: ObjectGeneric
  }>({
    title: t('reportFolio.modal.sendReport.titleQuestionnaire'),
    open: false,
    close: () => { },
    send: () => { },
    values: {}
  })
  const { columns, detail, closeMenu, addReportUrl, notFolioSelected, selectedIds, setNotFolioSelected, setSelectedIds, isChecked } = useTable({ row })
  const [openSnackbarReport, setOpenSnackbarReport] = useState({
    open: false,
    message: '',
    type: Types.SUCCESS as string,
  })
  const [modalDelete, setModalDelete] = useState<{
    open: boolean
    title: string
    description?: string
    children?: JSX.Element
    removeCancel?: boolean
    confirm: () => void
    id?: number,
    type: TypeDeleteSchedule
  }>({
    open: false,
    title: t('schedule.modal.confirmation'),
    description: t('schedule.modal.areYouSureWantDeleteAllSchedulingForTheSeries'),
    confirm: () => { },
    type: TypeDeleteSchedule.UNIQUE
  })
  const [snackbarOpen, setSnackbarOpen] = useState({
    open: false,
    message: '',
    type: Types.SUCCESS,
  })
  const [isLoadingDelete, setIsLoadingDelete] = useState(false)
  const [openPreview, setOpenPreview] = useState<{
    open: boolean
    userAssigned?: any
    questionnaire?: any
    directParents?: any
    createdByUser?: any
    stores?: any
  }>({
    open: false,
  })
  const {
    counter,
    errors,
    filterData,
    paginationModel,
    query,
    filterString,
    sortTable,
    handlePagination,
    onChange,
    cleanFilter,
  } = userSchedule
  const {
    download,
    openSnackbar,
    downloadCSV,
    downloadPDF,
    downloadWORD,
    closeOpenSnakbar,
  } = useDownload({
    docName: t('useScheduled.detail.snackbar.docName'),
    query: returnQueryWithPagination({
      filter: filterString.split('&')
        .filter(item => Boolean(item) && !(item.includes('programmed'))).join('&'),
      sort: query.sort,
    }, formOrder),
    downloadFuntion: userScheduleServiceFetch.downloadReport,
  })
  const [isLoadingConfirm, setIsLoadingConfirm] = useState(false)
  const [openSnackbarMain, setOpenSnackbarMain] = useState({
    message: '',
    type: Types.SUCCESS,
    open: false,
  })
  const [openModal, setOpenModal] = useState<{
    open: boolean
    title: string
    description: string
    submit?: boolean
    id?: number
    isClose?: boolean
    method: () => void
  }>({
    submit: true,
    open: false,
    title: t('schedule.modal.submit.title'),
    description: t('schedule.modal.submit.description'),
    method: () => { },
  })

  const handleCheanFilter = () => {
    disabledInputs({
      inputs: ['createYear', 'month', 'from', 'to'],
      value: false,
    })
    cleanFilter()
  }

  const handleCloseModal = () => {
    setOpenModal((prev) => ({
      ...prev,
      open: false,
    }))
  }

  const closeModalDelete = () => {
    setModalDelete(prev => ({
      ...prev,
      open: false,
    }))
  }

  const handleOpenModalDelete = () => {
    if (selectedIds.length === 0 && !isChecked) {
      setSnackbarOpen(prev => ({
        ...prev,
        open: true,
        message: t('schedule.snackbar.selectAtLeastOneSchedule'),
        type: Types.ERROR
      }))
    } else {
      setModalDelete(prev => ({
        ...prev,
        open: true,
        title: t('schedule.modal.confirmation'),
        description: t('schedule.modal.areYouSureWantDeleteAllSchedulingSelected',{count: selectedIds.length}),
        type: TypeDeleteSchedule.MASIVE
        //Agregar acá la funcion para eliminar
      }))
    }
  }

  const handleDeleteSchedules = async () => {
    setIsLoadingDelete(true)

    const payload = {
      all: isChecked,
      schedules_ids: isChecked ? [] : selectedIds,
      not_schedules_ids: isChecked ? notFolioSelected : []
    };

    let response;

    if (modalDelete.type == TypeDeleteSchedule.UNIQUE) {
       response = await userScheduleServiceFetch.deleteScheduleRecurrent(String(modalDelete.id));
    }

    if (modalDelete.type == TypeDeleteSchedule.SERIE) {
      response = await userScheduleServiceFetch.deleteScheduleSerie(String(modalDelete.id));
    }

    if (modalDelete.type == TypeDeleteSchedule.MASIVE) {
      response = await userScheduleServiceFetch.deleteScxheduleMasive(payload, isChecked ? returnQuery(query, formOrder) : undefined);
    }

    if (!response.errors) {
      if (modalDelete.type == TypeDeleteSchedule.UNIQUE) {
        setSnackbarOpen(prev => ({ ...prev, open: true, message: t('schedule.snackbar.delete.success.unique'), type: Types.SUCCESS }))
      }

      if (modalDelete.type == TypeDeleteSchedule.SERIE) {
        setSnackbarOpen(prev => ({ ...prev, open: true, message: t('schedule.snackbar.delete.success.serie'), type: Types.SUCCESS }))
      }

      if (modalDelete.type == TypeDeleteSchedule.MASIVE) {
        setSnackbarOpen(prev => ({ ...prev, open: true, message: t('schedule.snackbar.delete.success.masive',{count: selectedIds.length}), type: Types.SUCCESS }))
      }

      setSelectedIds([]);
      setNotFolioSelected([]);

      getUserSchedule({
        query: returnQuery(query, formOrder).split('&')
          .filter(item => Boolean(item) && !(item.includes('programmed'))).join('&'),
      })

    } else {
      if (modalDelete.type == TypeDeleteSchedule.UNIQUE) {
        setSnackbarOpen(prev => ({ ...prev, open: true, message: t('schedule.snackbar.delete.error.unique'), type: Types.ERROR }))
      }

      if (modalDelete.type == TypeDeleteSchedule.SERIE) {
        setSnackbarOpen(prev => ({ ...prev, open: true, message: t('schedule.snackbar.delete.error.serie'), type: Types.ERROR }))
      }

      if (modalDelete.type == TypeDeleteSchedule.MASIVE) {
        setSnackbarOpen(prev => ({ ...prev, open: true, message: t('schedule.snackbar.delete.error.masive',{count: selectedIds.length}), type: Types.ERROR }))
      }
    }

    setIsLoadingDelete(false)
    setModalDelete(prev => ({ ...prev, open: false }))
  }

  const handleCloseSnackbar = () => {
    setOpenSnackbarMain((prev) => ({
      ...prev,
      open: false,
    }))
  }
  const handleSendReportData: onChange = ({ target }) => {
    const { name, value } = target

    const body: ObjectGeneric = {
      ...structuredClone(resendReport.values),
      [name]: value,
    }

    /* START EMAIL VALIDATE */
    const emailValue = name === 'externalEmails' ? value : body?.externalEmails
    let emailIsSeparate = false
    emailIsSeparate = !(!emailValue || isEmailSeparateToCome(emailValue))
    /* END EMAIL VALIDATE */


    setDisabledModal((prev) => ({
      ...prev,
      resendButton:
        !Object.values(body ?? {})?.some((item) => !!item) || emailIsSeparate,
    }))

    setResendReport((prev) => ({
      ...prev,
      values: {
        ...prev?.values ?? {},
        [name]:
          name === 'externalEmails'
            ? value?.replace(/(\r\n|\n|\r|\s)/gm, '')
            : value,
      }
    }))
  }
  const optionMenu: OptionMenu = ({ item, type }) => {
    const menu: { [x: string]: () => void } = {
      '1': () => {
        //navigate(`/dashboard/schedule-user/${detail.id}`)
        navigate(`edit/${detail.id}`, {
          state: {
            option: detail.typeOption == FrequencyEnumTable.UNIQUE || detail.typeOption == FrequencyEnumTable.FRRE ? ScheduleEnumType.UNIQUE : ScheduleEnumType.RECURRENT
          }
        });
      },
      '2': () => {
        setOpenModal({
          ...openModal,
          title: t('schedule.modal.wantClose'),
          description: t('useScheduled.main.snackbars.descriptionClose'),
          id: detail.id,
          submit: false,
          open: true,
          isClose: true,
          method: async () => {
            if (detail.id) {
              setIsLoadingConfirm(true)
              const response = await userScheduleServiceFetch.closeUserSchedule(
                {
                  id: detail.id.toString(),
                }
              )
              if (!response.errors) {
                setOpenSnackbarMain((prev) => ({
                  ...prev,
                  message: t('useScheduled.main.snackbars.closeSuccess'),
                  type: Types.SUCCESS,
                }))

                getUserSchedule({ query: returnQuery(query, formOrder) })
              } else {
                setOpenSnackbarMain((prev) => ({
                  ...prev,
                  message: handleAllErrors(
                    response.errors,
                    t,
                    'useScheduled.main.snackbars.itWasAError'
                  ),
                  type: Types.ERROR,
                }))
              }
            }
            setIsLoadingConfirm(false)
            handleCloseModal()
          },
        })
      },
      '3': () => {
        if (detail?.reportUrl) {
          window.open(detail.reportUrl)
        } else {
          generateReport({ id: detail.id.toString() })
        }
      },
      '4': () => {
        const title = t(`reportFolio.modal.sendReport.titleQuestionnaire`)
        setResendReport(prev => ({
          ...prev,
          title,
          open: true,
          close: () => {
            setDisabledModal((prev) => ({
              ...prev,
              resendButton: true,
              resendButtonLoading: false,
            }))
            closeResendModal()
          },
          send: ({ data }: { data: ObjectGeneric }) => {
            submitResendReport({ id: detail.id.toString(), type, data, questionnaireOption: { id: item?.questionnaireId } })
          }
        }))
      },
      '5': () => {
        navigate(`detail/${detail.id}`)
      },
      '6': () => {
        navigate(`edit/${detail.id}`, {
          state: {
            option: ScheduleEnumType.SERIE
          }
        });
      },
      '7': () => {
        setModalDelete(prev => ({
          ...prev,
          open: true,
          title: t('schedule.modal.confirmation'),
          description: t('schedule.modal.areYouSureWantDeleteAllSchedulingForTheSeries'),
          id: detail.serieId, //AGREGAR ID DE LA SERIE
          type: TypeDeleteSchedule.SERIE
          //Agregar acá la funcion para eliminar
        }))
      },
      '8': () => {
        setModalDelete(prev => ({
          ...prev,
          open: true,
          title: t('schedule.modal.confirmation'),
          description: t('schedule.modal.deleteScheduleDescription'),
          id: detail.id, //ID DEL AGENDAMIENTO
          type: TypeDeleteSchedule.UNIQUE
          //Agregar acá la funcion para eliminar
        }))
      },
    }

    menu[item?.value]?.()
  }

  const generateReport = async ({ id }: { id: string }) => {
    const response = await userScheduleServiceFetch.getGenerateReport({ id })
    if (!response?.errors) {
      const reportUrl = formatGenerateReportResponse({ response })
      if (reportUrl) {
        setRow(prev => prev.map(row => {
          if (row.id == id) {
            return {
              ...row,
              reportUrl
            }
          }
          return row
        }))
        window.open(reportUrl)
      }
    }
  }
  const closeResendModal = () => {
    setResendReport(prev => ({ ...prev, open: false, values: {}, close: () => { }, send: () => { } }))
  }

  const handleCLoseOpenSnackbar = () => { setOpenSnackbarReport(prev => ({ ...prev, open: false })) }
  const submitResendReport: SubmitResend = ({ id, data, type, questionnaireOption }) => {
    setDisabledModal((prev) => ({
      ...prev,
      resendButtonLoading: true,
    }))

    const emails = data?.externalEmails
      ?.split(',')
      ?.filter((item: string) => !!item)

    let body: ObjectGeneric = {
      users_direct_parents: !!data?.users_direct_parents,
      user_creator: !!data?.user_creator,
      user_assign: !!data?.user_assign,
      type: type ?? resendReportTypes.report
    }

    if (!!emails?.length) body['external_emails'] = emails

    const localeId = questionnaireOption?.id ?? id
    const endpointResend = actionPlanFetch.sendReportScheduleUser

    endpointResend(localeId, body)
      .then((response) => {
        if (!response?.errors) {
          closeResendModal()
          setOpenSnackbarReport({
            open: true,
            type: Types.SUCCESS,
            message: t('general.reportSuccess'),
          })
        } else {
          setOpenSnackbarReport({
            open: true,
            type: Types.ERROR,
            message: handleAllErrors(response?.errors[0].code, t, t('general.reportError')),
          })
        }
      })
      .finally(() => {
        setDisabledModal((prev) => ({
          ...prev,
          resendButton: true,
          resendButtonLoading: false,
        }))
      })
  }

  const closeModal = () => {
    setOpenPreview((prev) => ({
      ...prev,
      stores: undefined,
      open: false,
    }))
  }

  useEffect(() => {
    executeFunction({
      execute: () => {
        getUserSchedule({
          query: returnQuery(query, formOrder).split('&')
            .filter(item => Boolean(item) && !(item.includes('programmed'))).join('&'),
        })
        setSelectedIds([]);
        setNotFolioSelected([]);
      }
    })
    //eslint-disable-next-line
  }, [query.all])
  useEffect(() => {
    userFilterData.getAllData()
  }, [])
  return (
    <Box key={'dashboard-reportFolio'} sx={styles.container}>
      <BreadCrumb
        notAddPath
      />
      {/* HEADER */}
      <Box sx={styles.header}>
        <Typography variant='title_grey_big'>
          {t('useScheduled.main.title')}
        </Typography>

        <Box sx={styles.flex}>
          <ModelDownloadButtons
            csv={downloadCSV}
            pdf={downloadPDF}
            word={downloadWORD}
            disableCSV={download?.excel}
            disablePDF={download?.pdf}
            disableWORD={download?.word}
            styleType
          />
          <Button /* sx={styles.deleteButon} */ variant="outlined" color="primary" onClick={handleOpenModalDelete}>
            {t('reportFolio.newDashboard.btnsHeader.delete')}
          </Button>

          {!!counter &&
            <Tooltip title={t('ToolTips.clearFilters')}>
              <IconButton
                sx={(styles.clean, (counter || 0) > 0 ? null : styles.hide)}
                onClick={() => {
                  handleCheanFilter()
                }}
              >
                {icons('clean')}
              </IconButton>
            </Tooltip>
          }
          <Tooltip title={t('ToolTips.create')}>
            <IconButton
              sx={styles.add}
              onClick={() => {
                navigate('create')
              }}
            >
              {icons('add')}
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      {/* MAIN COMPONENTS */}
      <CustomTable
        loader={isLoading}
        order={
          query.sort && {
            count: query.sort?.count,
            key: query.sort?.field,
            order: query.sort?.sort,
          }
        }
        sortable={(field, sort, count) => {
          sortTable(
            field && sort ? { field: field, sort: sort, count } : undefined
          )
        }}
        handleChange={(page: number, pageSize: number) => {
          handlePagination({ page, pageSize })
        }}
        serverSidePagination={{
          page: paginationModel.page + 1,
          size: paginationModel.pageSize,
          totalPages: endpointDetail?.total ?? 0,
        }}
        name={'Agenda de usuarios'}
        column={columns}
        row={row}
        color={colors}
        onClick={() => { }}
        selected={-1}
        setSelected={() => { }}
      />

      <FiltersDrawer
        cleanFilter={handleCheanFilter}
        count={counter}
        right={0}
        top={50}
      >
        <Box sx={styles.section}>
          <DinamicForm
            errors={errors}
            input={Object.values(input)}
            values={filterData}
            onChange={(e) => {
              handlePagination({ page: 1, pageSize: paginationModel.pageSize })
              onChange(e)
            }}
            filter={true}
          />
        </Box>
      </FiltersDrawer>

      <BaseMenu
        sx={[styles.baseMenu, detail.positionMenu]}
        anchorEl={detail.anchor}
        setAnchorEl={closeMenu}
        menuItems={detail.menu}
        click={(item) => {
          optionMenu({ item: item as Item })
        }}
      />
      <SnackSimple
        close={handleCloseSnackbar}
        open={openSnackbarMain.open}
        type={openSnackbarMain.type}
        message={openSnackbarMain.message}
      />

      <SnackSimple
        close={handleCLoseOpenSnackbar}
        open={openSnackbarReport.open}
        type={openSnackbarReport.type}
        message={openSnackbarReport.message}
      />
      <SnackSimple
        close={closeOpenSnakbar}
        open={openSnackbar.open}
        type={openSnackbar.type}
        message={openSnackbar.message}
      />
      <SnackSimple
        open={snackbarOpen.open}
        close={() => { setSnackbarOpen(prev => ({ ...prev, open: false })) }}
        message={snackbarOpen.message}
        type={snackbarOpen.type}
      />

      <DetailModal
        closeModal={closeModal}
        optionMenu={optionMenu}
        detail={detail}
        open={openPreview.open}
        createdByUser={openPreview.createdByUser}
        directParents={openPreview.directParents}
        questionnaire={openPreview?.questionnaire}
        userAssigned={openPreview?.userAssigned}
        stores={openPreview.stores}
      />

      <BaseModal sx={styles.resendModal as SxProps} open={resendReport?.open}>
        <Box style={styles.resendReportContainer as any}>
          <IconButton
            sx={styles.close}
            onClick={() => {
              resendReport.close()
            }}
          >
            {icons('simple-close')}
          </IconButton>

          <Typography sx={styles.titleSend}>{resendReport.title}</Typography>

          <DinamicForm input={Object.values(resendReportForm)} values={resendReport.values} onChange={handleSendReportData} spacing={{ row: 0 }} />

          <Typography sx={styles.titleSend}>{t('reportFolio.modal.sendReport.emails')}</Typography>

          <DinamicForm input={Object.values(resendReportFormEmails)} values={resendReport.values} onChange={handleSendReportData} />

          <Box sx={styles.resendButton}>
            <LoadingButton
              loading={!!disabledModal.resendButtonLoading}
              disabled={!!disabledModal?.resendButton}
              type="submit"
              onClick={() => {
                resendReport.send({ data: resendReport.values })
              }}
              sx={styles.button}
              variant="contained"
            >
              {t('reportFolio.buttons.resend')}
            </LoadingButton>
          </Box>
        </Box>
      </BaseModal>
      <SimpleModal
        open={openModal.open}
        close={handleCloseModal}
        title={openModal.title}
        description={openModal.description}
        buttonText={t('general.confirm')}
        cancelText={t('general.cancel')}
        color={colors}
        back={handleCloseModal}
        loadingButton
        isLoading={isLoadingConfirm}
        next={() => {
          openModal.method()
        }}
      />
      <SimpleModal
        open={!!modalDelete.open}
        next={handleDeleteSchedules}
        back={closeModalDelete}
        close={closeModalDelete}
        description={modalDelete.description}
        buttonText={t('general.confirm')}
        cancelText={t('general.cancel')}
        title={modalDelete.title}
        loadingButton
        isLoading={isLoadingDelete}
      //isLoading={isLoadingConfirm}
      /* sx={{ width: '470px' }}
      children={modal.children} */
      />
    </Box>
  )
}

export { UserScheduled }
